import axios from 'axios';
import { ADMIN_API_BASE, adminAuthConfig } from './api_admin';

const _err = (e) => { if (e.response) console.error('Admin partners error:', e.response.status, e.response.data); };
const qs = (p) => {
    const s = new URLSearchParams();
    Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') s.append(k, v); });
    return s.toString();
};

export const APIAdminPartners = async (token, params = {}) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/partners/?${qs(params)}`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPartnerDetail = async (token, id) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/partners/${id}/`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPartnerUpdate = async (token, id, data) => {
    try { const r = await axios.patch(`${ADMIN_API_BASE}/partners/${id}/update/`, data, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPartnerActivate = async (token, id) => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/partners/${id}/activate/`, {}, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPartnerDeactivate = async (token, id) => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/partners/${id}/deactivate/`, {}, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};